import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMyNetwork = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 19V3a1 1 0 0 1 2 0v16a1 1 0 0 0 1 1h16a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3zm15-7a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-9 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm11-3a3 3 0 0 1-5.206 2.033l-1.801.772a3 3 0 1 1-.788-1.838l1.802-.773a2.987 2.987 0 0 1 .592-1.993l-.862-1.293a3 3 0 1 1 1.764-4.564l5.256-1.314a1 1 0 0 1 .486 1.94l-5.257 1.314a2.983 2.983 0 0 1-.585 1.514l.861 1.293A3 3 0 0 1 19 12zm-8-6a1 1 0 1 0 2 0 1 1 0 0 0-2 0z",
		fill: "currentColor"
	})
});
export default SvgMyNetwork;
